<template>
  <v-card class="pa-10">
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <div class="close-model">
        <v-icon @click="$emit('closePopup')" large>mdi-close</v-icon>
      </div>
      <div>
        <h3>Kịch bản</h3>
        <div class="d-flex align-center px-5">
          <div class="label">
            <label for="">Tên kịch bản*</label>
          </div>
         <div class="input-script">
            <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Tên kịch bản"
          >
            <v-text-field
              :error-messages="errors"
              outlined
              dense
              placeholder="Nhập kịch bản"
              v-model="submit.name"
            />
          </validation-provider>
         </div>
        </div>
        <div class="d-flex align-center px-5">
          <div class="label">
            <label for="">Mã kịch bản*</label>
          </div>
          <div class="input-script">
          <validation-provider v-slot="{ errors }" rules="required" name="Code">
            <v-text-field
              :error-messages="errors"
              outlined
              dense
              placeholder="Nhập mã kịch bản"
              v-model="submit.code"
              :disabled="!_.isEmpty(itemScript)"
            />
          </validation-provider>
          </div>
        </div>
        <div class="d-flex align-center px-5" v-if="submit.type == 'auto'">
          <div class="label">
            <label for="">Chu kỳ* </label>
          </div>
          <div class="input-script">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Chu kỳ"
          >
            <v-text-field
              :error-messages="errors"
              outlined
              dense
              placeholder="Nhập số giờ"
              v-model="submit.periodTime"
            />
          </validation-provider>
          </div>
        </div>
        <div class="d-flex align-center px-5">
          <div class="label">
            <label for="">Kiểu* </label>
          </div>
          <div class="input-script">
          <validation-provider v-slot="{ errors }" rules="required" name="Kiểu">
            <v-autocomplete
              outlined
              :items="types"
              :error-messages="errors"
              dense
              placeholder="Chọn kiểu "
              v-model="submit.type"
              attach
              @change="changeType()"
            ></v-autocomplete>
          </validation-provider>
          </div>
        </div>
      </div>
      <div v-if="submit.type">
      <div v-for="(item) in submit.scriptDetail" :key="item.turnCalls" >
        <h3 class="mt-10"  v-if="submit.type == 'auto'">Lượt {{ item.turnCalls }}</h3>
        <div class="d-flex align-center px-5">
          <div class="label">
            <label for="">Cụm* </label>
          </div>
          <div class="input-script">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Brandname"
          >
            <v-autocomplete
              outlined
              :error-messages="errors"
              dense
              :placeholder="'Chọn group lượt ' + item.turnCalls"
              :items="groups"
              item-text="name"
              item-value="id"
              v-model="item.groupId"
            ></v-autocomplete>
          </validation-provider>
          </div>
        </div>
        <div class="d-flex align-center px-5" v-if="item.groupId">
          <div class="label">
            <label for="">Brandname* </label>
          </div>
          <div class="input-script">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="Brandname"
          >
            <v-autocomplete
              outlined
              :error-messages="errors"
              dense
              :items="groups"
              item-text="brandnameCode"
              item-value="id"
              v-model="item.groupId"
              disabled
            ></v-autocomplete>
          </validation-provider>
          </div>
        </div>
        <div class="d-flex align-center px-5"  v-if="submit.type == 'auto'">
          <div class="label">
            <label for="">Số lần gọi</label>
          </div>

          <div class="d-flex align-center  input-script">
            <div class="mr-2">
              <label for="">Từ</label>
            </div>
            <div class="input-number">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Từ"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  placeholder="Nhập số "
                  v-model="item.numberCallFrom"
                />
              </validation-provider>
            </div>
            <div class="mx-2">
              <label for="">Đến</label>
            </div>
            <div class="input-number">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Đến"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  placeholder="Nhập số "
                  v-model="item.numberCallTo"
              /></validation-provider>
            </div>
          </div>
        </div>
        <div class="delete-script" v-if="item.turnCalls !== 1" @click="deleteItemScript(item.turnCalls)">Xóa lượt</div>
      </div>
      <div class="add-script" @click="addScript()" v-if="submit.type == 'auto'">Thêm lượt</div>
     </div>
      <div class="submit-script pr-11 py-4">
        <v-btn rounded @click="$emit('closePopup')">Bỏ qua</v-btn>
        <v-btn rounded color="#FF6609" @click="handleSubmit(submitSave)"
          >Lưu lại</v-btn
        >
      </div>
    </validation-observer>
  </v-card>
</template>
<script>
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const ScriptRepository = RepositoryFactory.get("script");
export default {
  data() {
    return {
      itemBrand: {
        turnCalls: null,
        numberCallFrom: null,
        numberCallTo: null,
        brandnameCode: null,
        contactCondition: null,
        groupId: null,
      },
      submit: {
        name: null,
        code: null,
        periodTime: null,
        type: null,
        scriptDetail: [
          {
            turnCalls: 1,
            numberCallFrom: null,
            numberCallTo: null,
            brandnameCode: null,
            contactCondition: null,
            groupId: null,
          },
        ],
      },
      types: ["auto", "manual"],
      groups: []
    };
  },
  props: {
    // listBrands: {
    //   type: Array,
    //   default: () => [],
    // },
    itemScript: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    if(!_.isEmpty(this.itemScript)) {
      this.submit = this.itemScript
    };
    this.getListGroups()
    
  },
  methods: {
    async getListGroups() {
      const res = await ScriptRepository.getListGroups()
      this.groups = _.get(res, "data", []);
    },
    addScript() {
      this.submit.scriptDetail.push({...this.itemBrand, turnCalls:  this.submit.scriptDetail.length + 1});    
    },
    async submitSave() {
      this.submit.scriptDetail.map(s => {
      const find = _.find(this.groups, ['id', s.groupId])
      s.brandnameCode = find.brandnameCode
      return s
      })
      if(this.submit.type == 'manual') {
        delete this.submit.periodTime
      }
      let res
      if(!_.isEmpty(this.itemScript)) {
        let code = this.submit.code
        let params = _.omit(this.submit, 'code')   
        res = await ScriptRepository.updateBrand(code, params);
      }else {        
        res = await ScriptRepository.createBrand(this.submit);
      }
      
      if (res.success) {
        this.$swal({
          type: "success",
          title: !_.isEmpty(this.itemScript) ? 'Cập nhật thành công!' : "Tạo thành công!",
          timer: 1500,
        });
        this.$emit("getListBrands");
      }else {
        this.$swal({
          type: "error",
          title: "Lỗi !",
          timer: 1500,
          text: _.get(res, "message", ""),
        })
      }
    },
    deleteItemScript(turnCalls) {
      this.submit.scriptDetail.splice(turnCalls - 1 , 1)
      this.submit.scriptDetail.map((s, index) => {
        return s.turnCalls = index + 1
      })
    },
    changeType() {
      this.submit.scriptDetail = [
        {
          turnCalls: 1,
          numberCallFrom: null,
          numberCallTo: null,
          brandnameCode: null,
          contactCondition: null,
        },
      ]
    }
  }
}

</script>
<style scoped>
.label {
  min-width: 156px;
}
.input-script {
    width: calc(100% - 200px);
}
.add-script {
  display: flex;
  width: 85%;
  justify-content: center;
  color: #2f80ed;
  text-decoration: underline;
  cursor: pointer;
}
.delete-script {
  display: flex;
  width: 85%;
  justify-content: right;
  color: #2f80ed;
  text-decoration: underline;
  cursor: pointer;
}
.submit-script {
  display: flex;
  width: 100%;
  justify-content: right;
}
.close-model {
  position: absolute;
  top: 15px;
  right: 20px;
}
</style>
